const OrderOpinion = () => import('@pages/recovery/OrderOpinion')

export const recovery = [
  {
    path: '/recovery/order_opinion/:id',
    name: 'ROrderOpinion',
    component: OrderOpinion,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/recovery.route.js